import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=f08c8d16&scoped=true&"
import script from "./CCard.vue?vue&type=script&lang=ts&"
export * from "./CCard.vue?vue&type=script&lang=ts&"
import style0 from "./CCard.vue?vue&type=style&index=0&id=f08c8d16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08c8d16",
  null
  
)

export default component.exports